import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Modal from 'react-modal';
import './App.css';

Modal.setAppElement('#root');

const Facility = () => {
    const [facilities] = useState([
        {
            _id: '1',
            name: 'SWIMMING POOL',
            heading: 'SWIMMING POOL',
            description: 'Our swimming pool features a depth ranging from 4 to 7 feet, suitable for all ages. It includes a baby pool area for young children, surrounded by spacious decking for relaxation and fun.',
            image: '/images/pool20.webp' // Replace with actual base64 string
        },
        {
            _id: '2',
            name: 'GARDEN AREA',
            heading: 'GARDEN AREA',
            description: 'Experience a spacious garden area adorned with sheltering trees, creating an eco-friendly oasis. Enjoy fresh air in this serene environment, perfect for relaxation and rejuvenation.njoy a lively evening with friends, family, or colleagues.',
            image: '/images/shoot9.webp' // Replace with actual base64 string
        },
        {
            _id: '3',
            name: 'BAR AREA',
            heading: 'BAR AREA',
            description: 'Enjoy our bar area, where you’re welcome to bring your own cocktail bottles! Create your own concoctions and elevate your fun time with friends in a lively atmosphere. Let the good times flow!',
            image: '/images/pacl8.webp' // Replace with actual base64 string
        },
        {
                    _id: '4',
                    name: 'ACCOMMODATION',
                    heading: 'ACCOMMODATION',
                    description: 'Experience comfort in our three-story bungalow featuring seven modern, well-appointed rooms and a spacious living area. Enjoy a relaxing stay in a stylish and inviting environment, perfect for unwinding after a day of exploration.',
                    image: '/images/room3.webp' // Replace with actual base64 string
                },
                 {
                                    _id: '5',
                                    name: 'FOOD AND BEVERAGE',
                                    heading: 'FOOD AND BEVERAGE',
                                    description: 'Enjoy our delicious cuisine, expertly crafted with live cooking. Select your meals according to your preferences, ensuring a personalized and delightful dining experience.',
                                    image: '/images/food5.webp' // Replace with actual base64 string
                                }
    ]);

    return (
        <div>
            <div className="facility-header">
                <h2>Immerse Yourself in Comfort With Us...</h2>
            </div>
            <div className="facility-detail">
                <div className="facility-grid">
                    {facilities.length > 0 ? (
                        facilities.map((facility, index) => (
                            <div key={facility._id} className="facility-card">
                                <div className={`facility-row ${index % 2 === 0 ? 'even-row' : 'odd-row'}`}>
                                    <div className="facility-image-container">
                                        <img
                                            src={facility.image}
                                           
                                            className="facility-image"
                                        />
                                    </div>
                                    <div className="facility-info">
                                        <h2>{facility.heading}</h2>
                                        <p>{facility.description}</p>
                                    </div>
                                </div>
                            </div>
                        ))
                    ) : (
                        <p>No facilities available at the moment.</p>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Facility;
